export default __webpack_public_path__ + "static/media/past-work-glyph-16px.e7057f70.svg";